import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import { Response } from "@interfaces/response";
import { ContractualRevision } from "@interfaces/revision";

const revisionApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getContractualRevision: build.query<ContractualRevision, UUID>({
            query: (loanApplicationId) => ({
                url: `revision/contractuales/${loanApplicationId}`,
            }),
            transformResponse: (response: Response<ContractualRevision>) => {
                return response.data;
            },
        }),
    }),
});

export const { useLazyGetContractualRevisionQuery } = revisionApi;
